import {StatusPageTimeFormat} from "@/lib/types/statuspages.ts";
import {formatInTimeZone} from "date-fns-tz";

/**
 * Render an instant in the status page's timezone and 12/24-hour preference, as legacy's
 * localdatetime filter does (uptime/apps/lib/templatetags/uptime_tags.py:247). The zone
 * abbreviation stays: most visitors of a public page are not in the page's timezone.
 */
export const formatPageDateTime = (date: Date, timezone: string, timeFormat?: StatusPageTimeFormat): string => {
  const timeFmt = timeFormat === StatusPageTimeFormat.TWENTY_FOUR_HOUR ? "HH:mm:ss" : "hh:mm:ss a";
  return formatInTimeZone(date, timezone, `MMM d, yyyy ${timeFmt} zzz`);
};
